import React from "react";
import { Tabs } from "antd";

export const AdminTabs = ({
  activeKey,
  onChange,
  items = [],
  className = "",
  type = "card",
  size = "large",
}) => {
  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      type={type}
      size={size}
      className={`support-tabs ${className}`}
      items={items}
    />
  );
};

export default AdminTabs;
